import React from "react";
import PageHero from "../components/PageHero";
import FinalCTA from "../components/FinalCTA";
import FaqAccordion from "../components/FaqAccordion";
import { fullFaqs, pageHeroImages } from "../data/mockData";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../lib/seo";

const FaqPage = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: fullFaqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };
  return (
    <>
      <Seo {...PAGE_SEO.faq} jsonLd={faqSchema} />
      <PageHero
        eyebrow="FAQs"
        image={pageHeroImages.faq}
        title="Frequently Asked Questions"
        subtitle="Have a question? Below are some of the most common questions we get asked by homeowners, landlords and property owners across South Wales. If you can't find the answer you're looking for, simply call, WhatsApp or text us and we'll be happy to help."
      />

      <section className="py-16 lg:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <FaqAccordion items={fullFaqs} testId="full-faq" />
        </div>
      </section>

      <FinalCTA
        title="Still have a question?"
        lines={["We're always happy to help."]}
      />
    </>
  );
};

export default FaqPage;
